import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/First_level.vue'
// import Three_level from '../views/Three_level.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    
    component: HomeView
  },
  {
    path: '/second_level/:id',
    name: 'about',
    
    component: () => import(/* webpackChunkName: "about" */ '../views/Second_level.vue')
  },
  {
    path: '/three_level/:claster_id/:block/:pokazatel',
    name: 'three_level',
    
    component: () => import(/* webpackChunkName: "about" */ '../views/Three_level.vue')
  },
  {
    path: '/four_level/:claster_id/:block/:pokazatel',
    // path: '/four_level/:claster_id/:second_pokazatel',
    name: 'four_level',
    component: () => import(/* webpackChunkName: "about" */ '../views/Four_level.vue')
  },
  
  {
    path: '/Admin_panel',
    name: 'Admin_panel',
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin_panel.vue')
  },
  
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
